import React from 'react';
function User({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 19v-1.667c0-.884-.369-1.732-1.025-2.357A3.59 3.59 0 0015.5 14h-7a3.59 3.59 0 00-2.475.976A3.255 3.255 0 005 17.333V19M12 11a3 3 0 100-6 3 3 0 000 6z"
      />
    </svg>
  );
}

export default User;
